const Button = {
  variants: {
    primary: {
      backgroundColor: 'primary',
      color: 'white',
      borderRadius: '2xl',
      fontWeight: 'medium',
      fontSize: 'lg',
      _hover: {
        background: 'primary',
      },
      _active: {
        background: 'primary',
      },
      _loading: {
        _hover: {
          background: 'primary',
        },
      },
      sm: {
        borderRadius: 'xl',
        h: '3.5rem',
        fontSize: 'lg',
      },
      md: {
        h: '3.8rem',
      },
    },
  },
};

export default Button;
